 export const Currencies =[
    { name: "AED", value: "د.إ" },
    { name: "ALL", value: "L" },
    { name: "AMD", value: "Դ" },
    { name: "AOA", value: "Kz" },
    { name: "ARS", value: "$" },
    { name: "AUD", value: "$" },
    { name: "AWG", value: "ƒ" },
    { name: "AZN", value: "ман" },
    { name: "BAM", value: "КМ" },
    { name: "BBD", value: "$" },
    { name: "BDT", value: "৳" },
    { name: "BGN", value: "лв" },
    { name: "BHD", value: "ب.د" },
    { name: "BIF", value: "FBu" },
    { name: "BMD", value: "$" },
    { name: "BND", value: "$" },
    { name: "BOB", value: "Bs." },
    { name: "BRL", value: "R$" },
    { name: "BSD", value: "$" },
    { name: "BWP", value: "P" },
    { name: "BYN", value: "Br" },
    { name: "BZD", value: "$" },
    { name: "CAD", value: "$" },
    { name: "CHF", value: "₣" },
    { name: "CLP", value: "$" },
    { name: "CNY", value: "¥" },
    { name: "COP", value: "$" },
    { name: "CRC", value: "₡" },
    { name: "CUP", value: "$" },
    { name: "CVE", value: "$" },
    { name: "CZK", value: " Kč" },
    { name: "DJF", value: "₣" },
    { name: "DKK", value: "kr." },
    { name: "DOP", value: "$" },
    { name: "DZD", value: "د.ج" },
    { name: "EGP", value: "£" },
    { name: "ERN", value: "Nfk" },
    { name: "ETB", value: "ብር" },
    { name: "EUR", value: "€" },
    { name: "FJD", value: "$" },
    { name: "FKP", value: "£" },
    { name: "GBP", value: "£" },
    { name: "GEL", value: "ლ" },
    { name: "GHS", value: "₵" },
    { name: "GIP", value: "£" },
    { name: "GMD", value: "D" },
    { name: "GNF", value: "₣" },
    { name: "GTQ", value: "Q" },
    { name: "GYD", value: "$" },
    { name: "HKD", value: "$" },
    { name: "HNL", value: "L" },
    { name: "HRK", value: "Kn" },
    { name: "HTG", value: "G" },
    { name: "HUF", value: "Ft" },
    { name: "IDR", value: "Rp" },
    { name: "ILS", value: "₪" },
    { name: "INR", value: "₹" },
    { name: "IRR", value: "﷼" },
    { name: "ISK", value: "Kr" },
    { name: "JMD", value: "$" },
    { name: "JPY", value: "¥" },
    { name: "KES", value: "Sh" },
    { name: "KGS", value: "som" },
    { name: "KHR", value: "៛" },
    { name: "KMF", value: "francs" },
    { name: "KRW", value: "₩" },
    { name: "KYD", value: "$" },
    { name: "KZT", value: "〒" },
    { name: "LAK", value: "₭" },
    { name: "LBP", value: "ل.ل" },
    { name: "LKR", value: "Rs" },
    { name: "LRD", value: "$" },
    { name: "LSL", value: "L" },
    { name: "MAD", value: "د.م." },
    { name: "MDL", value: "L" },
    { name: "MKD", value: "ден" },
    { name: "MMK", value: "K" },
    { name: "MNT", value: "₮" },
    { name: "MOP", value: "P" },
    { name: "MUR", value: "₨" },
    { name: "MVR", value: "  ރ." },
    { name: "MWK", value: "MK" },
    { name: "MXN", value: "Mex$" },
    { name: "MYR", value: "RM" },
    { name: "NOK", value: "kr" },
    { name: "NZD", value: "$" },
    { name: "PHP", value: "₱" },
    { name: "PLN", value: "zÅ‚" },
    { name: "GBP", value: "£" },
    { name: "RUB", value: "руб" },
    { name: "SGD", value: "S$" },
    { name: "SEK", value: "kr" },
    { name: "CHF", value: "SFr." },
    { name: "TWD", value: "$" },
    { name: "THB", value: "฿" },
    { name: "TRY", value: "TL" },
    { name: "USD", value: "$" }
  ];

